const serverUrlHandler = (hostURL) => {
  if (hostURL.includes('localhost') || hostURL.includes('dev')) {
    return 'https://icma-dev.siemens-energy.cloud/';
  }
  if (hostURL.includes('qa')) {
    return 'https://icma-qa.siemens-energy.cloud/';
  } else {
    return 'https://icma.siemens-energy.cloud/';
  }
};

const redirectUrlHandler = (urlObject) => {
  // if you have url parameter then use it if not default case
  if (urlObject.searchParams.get('backtocep') != null) {
    return urlObject.searchParams.get('backtocep');
  } else {
    return 'https://cep.siemens-energy.com';
  }
};

const dataFormatter = (validaDate) => {
  return (
    validaDate.getFullYear() +
    '-' +
    (validaDate.getMonth() + 1) +
    '-' +
    validaDate.getDate()
  );
};

const dateGenerator = () => {
  const today = new Date();
  today.setDate(today.getDate() - 1);
  let endDate = dataFormatter(today);
  today.setDate(today.getDate() - 1);
  let startDate = dataFormatter(today);
  return {
    startDate,
    endDate,
  };
};
const languageManager = (language) => {
  if (language != 'en' && language != 'de') {
    // default language/unsupported language default to english
    return 'en';
  }
  return language;
};

const generateParamsObj = (
  ppid = null,
  language,
  urlObject,
  sid = null,
  ibid = null
) => {
  let { startDate, endDate } = dateGenerator();
  let loginMethod='Auth0'
  if(localStorage.getItem('icma_sso')==='az'){
    loginMethod='az'
  }
  return {
    endDate: endDate,
    language: languageManager(language),
    ppid: ppid,
    server: serverUrlHandler(urlObject['hostname']),
    startDate: startDate,
    loginMethod: loginMethod,
    redirectUrlCep: redirectUrlHandler(urlObject),
    sid: sid,
    ibid: ibid,
  };
};

module.exports = function (elementId) {
  // const id = elementId || 'params';
  // const element = document.getElementById(id);

  // for cep portal parameters if native app already loadded
  let paramsObj = {};
  if (document.getElementById('params') != null) {
    // console.log('<--loading CEP (ICMA Widget)-->');
    // case to get parameter from inside div (widetpage)
    paramsObj = document.getElementById('params').innerHTML;
    paramsObj = JSON.parse(paramsObj);
    paramsObj = paramsObj.content.parameters;
    window.$globalSettings = paramsObj;
    return paramsObj;
  }
  // To get the parameter for native app if it is getting loaded for the first time
  // console.log('<--loading CEP portal(Native app)-->');
  let urlObject = new URL(window.location.href);
  // if parameters are blank
  if (
    urlObject.searchParams.get('ppid') != null &&
    urlObject.searchParams.get('language') != null &&
    !window.$globalSettings
  ) {
    paramsObj = generateParamsObj(
      urlObject.searchParams.get('ppid'),
      urlObject.searchParams.get('language'),
      urlObject,
      urlObject.searchParams.get('sid'),
      urlObject.searchParams.get('ibid')
    );
  }
  // for local development (localhost:3000) and for widgetpage
  else {
    // case to get parameter for services from native application
    // console.log('ICMA Native app already loaded');
    paramsObj = window.$globalSettings;
    if (paramsObj == undefined || paramsObj.ppid == undefined) {
      console.log('handling local development');
      // case to handle parameter on local development
      let ppid = urlObject.searchParams.get('ppid') || 'BLANK';
      let language = urlObject.searchParams.get('language') || 'en';
      let sid = urlObject.searchParams.get('sid') || 'BLANKSID';
      let ibid = urlObject.searchParams.get('ibid') || 'BLANKIBID';
      paramsObj = generateParamsObj(ppid, language, urlObject, sid, ibid);
      // console.log('self initialing the params');
    }
  }
  window.$globalSettings = paramsObj;
  return paramsObj;
};
